import { render, staticRenderFns } from "./_base-transition.vue?vue&type=template&id=0fc206af&scoped=true&"
import script from "./_base-transition.vue?vue&type=script&lang=js&"
export * from "./_base-transition.vue?vue&type=script&lang=js&"
import style0 from "./_base-transition.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./_base-transition.vue?vue&type=style&index=1&id=0fc206af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc206af",
  null
  
)

export default component.exports